import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

const Card = ({ className = '', children, ...rest }) => (
  <div className={cx('card', className)} {...rest}>
    {children}
  </div>
);

Card.propTypes = {
  className: PropTypes.string,
  chidlren: PropTypes.node,
};

export default Card;
